import React from 'react'
import SuperUserLoanPageUI from '../../../templates/SuperUserLoanPageUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import BroadTermsSF from '../../../components/superUser/loan/BroadTermsSF'
import PageTitleUI from '../../../widgets/output/PageTitleUI'

const BroadTermsPageUI = ({context, errorList, loan}) =>
  <SuperUserLoanPageUI context={context} className='pg_su_loan_a'
    headerText={`Broad Terms: ${loan ? loan.account.accountName : ''}`}
    centered={!loan}
    backLink={`/su/loans/${loan ? loan.loanId : ''}`}
    loan={loan}
    page='broadTerms'
    >
    {
      (!loan) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan &&
      <div>
        <PageTitleUI context={context} goBack={false}
          backLink={null}
          titleText={`Broad Terms: ${loan ? loan.account.accountName : ''}`} />
        <BroadTermsSF context={context} loan={loan} />
      </div>
    }

  </SuperUserLoanPageUI>

export default BroadTermsPageUI


